module.exports = __webpack_public_path__ + "stockLibrary/simulator/009-e1ae0f28a5eb37236de5bacab21556a5.png";